import React, { useState } from 'react';
import { CheckCircle2, Info, AlertTriangle, XCircle, X } from 'lucide-react';

const VARIANT = {
  success: {
    wrap: 'bg-emerald-50 border-emerald-200 text-emerald-800',
    title: 'text-emerald-900',
    body:  'text-emerald-700',
    Icon:  CheckCircle2,
  },
  info: {
    wrap: 'bg-sky-50 border-sky-200 text-sky-800',
    title: 'text-sky-900',
    body:  'text-sky-700',
    Icon:  Info,
  },
  warning: {
    wrap: 'bg-amber-50 border-amber-200 text-amber-800',
    title: 'text-amber-900',
    body:  'text-amber-700',
    Icon:  AlertTriangle,
  },
  danger: {
    wrap: 'bg-rose-50 border-rose-200 text-rose-800',
    title: 'text-rose-900',
    body:  'text-rose-700',
    Icon:  XCircle,
  },
};

export function Alert({ variant = 'info', title, children, dismissible = false, className = '' }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const v = VARIANT[variant] || VARIANT.info;
  return (
    <div className={`flex items-start gap-3 p-3.5 rounded-lg border ${v.wrap} ${className}`}>
      <v.Icon size={15} strokeWidth={1.75} className="flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        {title && <div className={`font-semibold text-[13px] ${v.title}`}>{title}</div>}
        {children && <div className={`text-[12.5px] mt-0.5 ${v.body}`}>{children}</div>}
      </div>
      {dismissible && (
        <button
          onClick={() => setDismissed(true)}
          className="flex-shrink-0 w-5 h-5 grid place-items-center rounded opacity-60 hover:opacity-100 transition"
        >
          <X size={13} />
        </button>
      )}
    </div>
  );
}

export function Toast({ variant = 'success', title, body, onClose }) {
  const v = VARIANT[variant] || VARIANT.success;
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-lg px-4 py-3 flex items-center gap-3 animate-slide-in">
      <v.Icon size={15} strokeWidth={1.75} className={variant === 'success' ? 'text-emerald-500' : variant === 'warning' ? 'text-amber-500' : 'text-rose-500'} />
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-semibold text-slate-900">{title}</div>
        {body && <div className="text-[11.5px] text-slate-500">{body}</div>}
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="w-6 h-6 grid place-items-center rounded text-slate-400 hover:bg-slate-100 text-[11px] flex-shrink-0"
        >
          <X size={12} />
        </button>
      )}
    </div>
  );
}

export function ToastContainer({ toasts = [], onClose }) {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-72">
      {toasts.map((t) => (
        <Toast key={t.id} {...t} onClose={() => onClose?.(t.id)} />
      ))}
    </div>
  );
}

export default Alert;
